<template>
  <span
    v-if="emitOnlyClick"
    :class="linkClass"
    class="pagination-link"
    @click="emitClick"
  >
    {{ page }}
  </span>
  <nuxt-link
    v-else
    :class="linkClass"
    :to="url"
    class="pagination-link"
  >
    {{ page }}
  </nuxt-link>
</template>

<script>
export default {
  name: 'PaginationLink',
  props: {
    page: {
      type: Number,
      required: true,
    },
    url: {
      type: [Object, String, Number],
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    emitOnlyClick: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    linkClass() {
      return {
        'pagination-link--active': this.active,
      };
    },
  },
  methods: {
    emitClick() {
      this.$emit('click', this.url);
    },
  },
};
</script>

<style lang="scss">
@use 'assets/base' as *;

.pagination-link {
  color: color(grey, 12000);
  text-decoration: none;
  border-radius: 54px;
  border: 1px solid color(grey, 20000);
  height: 36px;
  width: 57px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:visited,
  &:active {
    color: color(grey, 12000);
  }

  &:hover,
  &:focus,
  &--active {
    color: color(grey, 12000);
    background-color: color(grey, 29000);
  }
}
</style>
